<template>
    <footer class="pc-body aaa">
        <div class="footer-container">
            <div class="footer footer-mod-1">
                <div class="logo-wrap">
                    <img class="pc-logo show-pc" src="~IMAGE/footer/footer-logo.png" usemap="#footer-logo" alt="Reolink cloud"/>
                    <map name="footer-logo">
                        <area shape="rect" coords="0,0,135,36" alt="reolink" :href="getOfficialUrl( `${config.reolink}/` )" target="_blank">
                        <area shape="rect" coords="155,0,200,36" alt="reolink" href="/">
                    </map>
                    <p class="show-pc footer-logo-desc">{{ $t("footer.logo") }}<span>{{ $t("footer.cloud") }}</span></p>
                    <img class="m-logo show-m" src="~IMAGE/footer/footer-logo-m.png" usemap="#footer-logo-m" alt="Reolink cloud"/>
                    <map name="footer-logo-m">
                        <area shape="rect" :coords="`0,0,${x1},${height}`" alt="reolink" :href="getOfficialUrl( `${config.reolink}/` )" target="_blank">
                        <area shape="rect" :coords="`${x2},0,${width},${height}`" alt="reolink" href="/">
                    </map>
                </div>
                <div class="payment-wrap">
                    <ul class="payment">
                        <li>
                            <a :href="config.app_store" target="_blank">
                                <i class="icon-icon_apple-store"></i>
                                <span>{{ $t("footer.app_store") }}</span>
                            </a>
                        </li>
                        <li>
                            <a :href="config.google_play" target="_blank">
                                <i class="icon-icon_google-play"></i>
                                <span>{{ $t("footer.google_pay") }}</span>
                            </a>
                        </li>
                        <li>
                            <router-link :to="{path:'/user/dashboard/'}">
                                <i class="icon-icon_cloud"></i>
                                <span>{{ $t("footer.link_cloud") }}</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="footer footer-mod-2">
                <p>
                    <template v-if="!FEATURE('footer.store')">
                        <a :href="config.officialStore" target="_blank">{{ $t("footer.reolinkStore") }}</a><span>|</span>
                        <a :href="config.support_team" target="_blank">{{ $t("footer.support") }}</a><span>|</span>
                    </template>
                    <a :href="getOfficialUrl( config.about_us )" target="_blank">{{ $t("footer.aboutUs") }}</a><span>|</span>
                    <a :href="getOfficialUrl( config.privacy )" target="_blank">{{ $t("footer.policy") }}</a><span>|</span>
                    <a :href="getOfficialUrl( config.conditions )" target="_blank">{{ $t("footer.term") }}</a>
                </p>
                <p class="desc">{{ $t("footer.copyright") }}</p>
            </div>
            <div class="footer footer-mod-3" v-if="FEATURE('footer.gov_record')">
                <a href="https://szcert.ebs.org.cn/5545244d-6095-4d20-93c3-9508e4908110" target="_blank">
                    <img src="https://szcert.ebs.org.cn/Images/newGovIcon.gif" title="深圳市市场监督管理局企业主体身份公示" alt="深圳市市场监督管理局企业主体身份公示" width="90" height="40" border="0">
                </a>
                <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" class="footer-code">粤ICP备2020102099号</a>
                <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602005063" style="margin-left: 0.1rem">
                    <img src="https://home.cdn.reolink.com.cn/wp-content/uploads/2019/08/备案图标.png">
                    <span class="footer-code">粤公网安备 44030602005063号</span>
                </a>
            </div>
        </div>
    </footer>
</template>
<script>
import { config } from 'CONFIG';
export default {

    data () {

        return {

            x1: 0,
            x2: 0,
            height: 0,
            width: 0,
            config

        };

    },

    mounted () {

        window.addEventListener( 'resize', this.resizeHandle );
        this.calStyle();

    },

    methods: {

        calStyle () {

            let logo = $( '.footer-container .m-logo.show-m' );
            let width = logo[ 0 ].offsetWidth;
            this.x1 = width * 0.46;
            this.x2 = width * 0.57;
            this.width = width;
            this.height = width * 0.125;

        },
        resizeHandle () {

            this.calStyle();

        }

    },

    destroyed () {

        window.removeEventListener( 'resize', this.resizeHandle );

    }
};
</script>
<style type="text/css" lang="less">
    footer.pc-body {
        background-color: #2B2B2B;
        padding: .98rem 15px .8rem;
    }

    footer.pc-body .show-m {
        display: none !important;
    }

    footer.pc-body .footer-container {
        max-width: 1200px;
        margin: 0 auto;
    }

    footer.pc-body .footer{
        margin: 0 auto;
        color: #fff;
    }

    footer.pc-body .footer-mod-1 {
        padding-bottom: .28rem;
        border-bottom: 1px solid #707070;
        margin-bottom: .25rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    footer.pc-body .footer-mod-1 .logo .pc-logo {
        width: 2rem;
        height: .36rem;
        margin-bottom: .04rem;
    }

    footer .m-logo.show-m {
        width: 2.87rem;
        margin: 0 auto;
    }

    footer.pc-body .footer-logo-desc{
        display: block;
        font-size: .12rem;
        color: #fff;
    }

    footer.pc-body .footer-logo-desc span{
        margin-left: .3rem;
    }

    footer.pc-body .payment li{
        display: inline-block;
        font-size: .16rem;
        font-weight: 500;
        vertical-align: middle;
        box-sizing: border-box;
    }

    footer.pc-body .payment li i {
        margin-right: .15rem;
        font-size: .18rem;
    }

    footer .footer-mod-1 .payment-wrap li a:hover{
        color: @theme;
    }

    footer.pc-body .payment li img{
        margin-right: .23rem;
        height: .26rem;
        width: auto;
    }

    footer.pc-body .payment li + li{
        margin-left: .25rem;
    }

    footer .footer-mod-1 .payment-wrap li a {
        color: #fff;
    }

    footer.pc-body .footer-mod-2{
        color: #999;
        text-align: right;
        font-weight: 500;
    }

    footer.pc-body .footer-mod-2 a{
        color: #999;
        font-size: .14rem;
        font-weight: 500;
    }

    footer.pc-body .footer-mod-2 a:hover{
        color: #fff;
    }

    footer.pc-body .footer-mod-2 a + span{
        padding: 0 .15rem;
    }

    footer.pc-body .footer-mod-2 .desc{
        font-size: .12rem;
        margin-top: .08rem;
        font-weight: 500;
    }

    footer.pc-body .payment  li .img-site {
        width: 1.33rem;
        height: auto;
        vertical-align: middle;
        margin-right: 0;
    }

    @media screen and (max-width: 1199px) {

        footer.pc-body {
            padding: 0.6rem 15px 0.48rem;
        }

        body.has-cart-total footer.pc-body{
            padding-bottom: 2rem;
        }

        footer.pc-body.has-handle{
            padding-bottom: 1.48rem;
        }

        footer.pc-body .show-pc {
            display: none !important;
        }

        footer.pc-body .show-m {
            display: block !important;
        }

        footer.pc-body .footer-mod-1 {
            display: block;
            padding-bottom: 0;
            text-align: center;
            border: none;
            margin-bottom: 0.6rem;
        }

        footer.pc-body .footer-mod-1 .payment-wrap {
            margin-top: 0.6rem;
            padding: 0 1rem;
        }

        footer.pc-body .footer-mod-1 .payment {
            display: flex;
            justify-content: space-between;
        }

        footer.pc-body .footer-mod-1 .payment-wrap li a {
            width: 2.2rem;
            height: 1.3rem;
            padding: 0.22rem 0 0.14rem;
            display: flex;
            flex-flow: column;
            justify-content: space-between;
            background-color: #494b4d;
            border-radius: 10px;
            box-sizing: border-box;
        }

        footer.pc-body .payment li {
            font-size: 0.22rem;
        }

        footer.pc-body .payment  li .img-site,
        footer.pc-body .payment li i {
            margin: 0 auto;
        }

        footer.pc-body .payment  li .img-site {
            width: 1.78rem;
        }

        footer.pc-body .payment li i  {
            font-size: 0.35rem;
        }

        footer.pc-body .footer-mod-2 {
            text-align: center;
        }

        footer.pc-body .footer-mod-2 a {
            font-size: 0.22rem;
        }

        footer.pc-body .footer-mod-2 a + span {
            font-size: 0.22rem;
            padding: 0 0.26rem;
        }

        footer.pc-body .footer-mod-2 .desc {
            margin-top: 0.14rem;
            font-size: 0.2rem;
        }

    }

    @media screen and (max-width: 800px) {
        footer.pc-body .footer-mod-1 .payment-wrap {
            padding: 0;
        }
    }

    footer.pc-body .footer-mod-3 {
        text-align: center;
        margin-top: .2rem;

        a {
            display: inline-block;
            vertical-align: middle;
            color: #999;
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/Footer.vue